import { Component } from '@angular/core';

@Component({
  selector: 'app-nested-sidebar-otdr-poster',
  templateUrl: '../../templates/Template-nested-sidebar-lead.html',
  styleUrl: './nested-sidebar-otdr-poster.component.scss'
})
export class NestedSidebarOtdrPosterComponent {

  pdf = {
    pdfTitle: 'Optical Time Domain Reflectometer (OTDR) Poster',
    pdfimg: './assets/images/sidebar/D99_00_017P_OTDR Basics Poster_Unlocked.png',
    url: 'otdrbasics',
    opt: 'BUTTON.DOWNLOAD',
    width: '600',
    height: '400'
  };
}
